import React from "react";
import Login from "../component/Login/Login";

function LoginPage() {
  return <Login />;
}

export default LoginPage;
